const REQUEST_ACCESS_TOKEN = 'requestAccessToken';
const SET_TITLE = 'setTitle';
const LOGOUT = 'logout';
const CLOSE = 'close';
const GET_URL = 'getUrl';
const APP_NAME = 'ELECTRONIC JOURNAL';
const RETAIL_AUTH = 'retail';
const OKTA_AUTH = 'okta';
const TRUE_APP = 'true';
const NPOS_APP = 'NPOS';
const APPLE_WEBKIT = 'AppleWebKit';
const TOKEN_V1 = 'v1';
const TOKEN_V2 = 'v2';
const MAXIMUM_ITEM_DESCRIPTION_LENGTH = 27;
const MAX_ITEM_DESC_LENGTH = 24;
const SNOW_EJ_ASSIGNMENT_GROUP = '202ff2a5dbb13050b30c0afed3961999';
const SNOW_CREATE_INCIDENT_URL = `https://niketech.service-now.com/nav_to.do?uri=%2Fincident.do%3Fsys_id%3D-1%26sys_is_list%3Dtrue%26sys_target%3Dincident%26sysparm_checked_items%3D%26sysparm_fixed_query%3D%26sysparm_group_sort%3D%26sysparm_list_css%3D%26sysparm_query%3Dactive%3Dtrue%5Eassignment_group%3D${SNOW_EJ_ASSIGNMENT_GROUP}%26sysparm_referring_url%3Dincident_list.do%3Fsysparm_query%3Dactive%253Dtrue%255Eassignment_group%253D${SNOW_EJ_ASSIGNMENT_GROUP}@99@sysparm_first_row%3D1%26sysparm_target%3D%26sysparm_view%3D%26sysparm_view_forced%3Dtrue`;

const RECEIPT_NUMBER = 'Receipt Number';

const WEBSITE_URL_NIKE = 'http://www.nike.com';
const WEBSITE_URL_JORDAN = 'http://www.jordan.com';

const NIKE = 'NIKE';
const JORDAN = 'JORDAN';
const WORLD_OF_FLIGHT = 'World of Flight';

const NEGATIVE_AMOUNT_FORMAT_LOCALES = [
  'ja-JP',
  'zh-HK',
  'zh-MO',
  'zh-TW',
  'zh-CN',
];

const WAIT_SECONDS_BEFORE_FAIL = 7000;

/** Configurations for filters in 'More' Section */
const MORE_FILTERS_CONFIG = {
  athleteLoginNumber: {
      defaultValue: '',
      searchKey: 'athleteLoginNumber',
  },
  emailId: {
      defaultValue: '',
      searchKey: 'billToEmail',
  },
  freeText: {
      defaultValue: '',
      searchKey: 'freeText'
  },
  maximumAmount: {
      defaultValue: '',
      searchKey: 'maximumAmount'
  },
  minimumAmount: {
      defaultValue: '',
      searchKey: 'minimumAmount'
  },
  modifierEmployeeDiscount: {
      defaultValue: false,
      searchKey: 'employeeDiscount'
  },
  modifierGeneralDiscounts: {
      defaultValue: false,
      searchKey: 'generalDiscount'
  },
  modifierPriceOverride: {
      defaultValue: false,
      searchKey: 'priceOverride'
  },
  modifierPromotion: {
      defaultValue: false,
      searchKey: 'promotion'
  },
  o2oEvent: {
      defaultValue: '',
      searchKey: 'o2oEvents'
  },
  orderId: {
      defaultValue: '',
      searchKey: 'orderId'
  },
  originalTransactionNo: {
      defaultValue: '',
      searchKey: 'originalTransactionNumber'
  },
  registerNumber: {
      defaultValue: '',
      searchKey: 'registerNumber'
  },
  statusDelivered: {
      defaultValue: false,
      searchKey: 'delivered'
  },
  statusResume: {
      defaultValue: false,
      searchKey: 'resume'
  },
  statusSuspend: {
      defaultValue: false,
      searchKey: 'suspend'
  },
  statusVoid: {
      defaultValue: false,
      searchKey: 'void'
  },
  tillNo: {
      defaultValue: '',
      searchKey: 'tillId'
  },
  transactionNo: {
      defaultValue: '',
      searchKey: 'transactionNumber'
  },
  transactionType: {
      defaultValue: 'RetailTransaction',
      searchKey: 'transactionType'
  },
  transactionUuid: {
      defaultValue: '',
      searchKey: 'transactionUUID'
  }
};

const NPOS = {
  ACTIONS: {
    CHANGE_LANGUAGE: 'NPOS_ACTION_CHANGE_LANGUAGE',
    SESSION_CONTEXT: 'NPOS_ACTION_SESSION_CONTEXT',
  },
  COLORS: {
    DATEPICKER: {
      DEFAULT: '#000000',
      FUTURE_DATE: '#E5E5E5',
      START_END_DATE: '#FFFFFF',
    },
  },
  DAY_END_TIME: { label: '11:59 PM', value: '23:59:59' },
  DAY_START_TIME: { label: '12:00 AM', value: '00:00:00' },
  ERROR_CODES: {
    INVALID_RECEIPT_IMAGE: 'Data invalid/corrupted',
    PRINTER_NOT_FOUND: 'Hardware Not Connected',
    STARTDATE_GT_ENDDATE: 'STARTDATE_GT_ENDDATE',
    STARTIME_GT_ENDTIME: 'STARTIME_GT_ENDTIME',
  },
  ERRORS: {
    INVALID_CREDIT_DEBIT_CARD_NUMBER: 'RL_ErrCardNoDigits',
    INVALID_GIFT_CARD_NUMBER: 'RL_ErrGiftCardNoDigits',
    INVALID_UPC: 'RL_ErrUpcNoDigits',
    STARTDATE_GT_ENDDATE: 'RL_ErrStartDate',
    STARTIME_GT_ENDTIME: 'RL_ErrFromTime',
  },
  FILTERS: {
    MORE: 'MORE',
    MORE_FILTERS_CONFIG,
    PAYMENT_TYPE: 'PAYMENT_TYPE',
    PURCHASE_DATE: 'PURCHASE_DATE',
    UPC: 'UPC'
  },
  MESSAGES: {
    ADJUST_FILTERS: 'RL_MsgAdjustFilters',
    ADJUST_FILTERS_AND_SEARCH: 'RL_MsgAdjustSearch',
    FETCH_ERROR: 'RL_ErrFetchError',
    NO_RECENT_TRANSACTIONS: 'RL_ErrNoRecentTransactions',
    NO_RESULTS: 'RL_ErrNoResults',
    SEARCH_TRANSACTIONS: 'RL_MsgSearchTransactions',
  },
  PAYMENT_TYPE: {
    CASH: 'Cash',
    COMPLIMENTARY: 'StoreAccount',
    CREDIT_DEBIT_CARD: 'CreditDebit',
    GIFT_CARD: 'GiftCard'
  },
  PRINT_RESPONSE: {
    ERROR: 'NPOS_RESPONSE_PRINT_FAILURE',
    SUCCESS: 'NPOS_RESPONSE_PRINT_SUCCESS'
  },
  PRINT_STATUS: {
    ERROR: 'ERROR',
    IN_PROGRESS: 'IN_PROGRESS',
    INITIATED: 'INITIATED',
    SUCCESS: 'SUCCESS',
  },
  SKELETON_ROW_COUNT: 5
};

const WORKSTATION_TYPE_CODES = {
  NikePOSInCloud: 'NikePOSInCloud',
  NikePOSRegister: 'NikePOSRegister',
  SelfCheckoutStation: 'SelfCheckoutStation',
};

const MOMENT_DATE_FORMAT = 'YYYY-MM-DD';

const ERROR_CODES = {
  E_INVALID_RECEIPT_IMAGE: 'E1001', // Unable to parse receipt image at NPOS
  E_UNKNOWN_NPOS_PRINT_STATUS: 'E1000', // Unknown print status received from NPOS
};
const RIGHT_TO_LEFT_LOCALES = ['he-IL'];

const TRANSLATIONS = {
  REPRINT_UNAVAILABLE: {
    INVALID_WORKSTATION_TYPE: 'RL_InfoMsgOnlyPOS'
  },
};

module.exports = {
  APP_NAME,
  APPLE_WEBKIT,
  CLOSE,
  ERROR_CODES,
  GET_URL,
  JORDAN,
  LOGOUT,
  MAX_ITEM_DESC_LENGTH,
  MAXIMUM_ITEM_DESCRIPTION_LENGTH,
  MOMENT_DATE_FORMAT,
  NEGATIVE_AMOUNT_FORMAT_LOCALES,
  NIKE,
  NPOS,
  NPOS_APP,
  OKTA_AUTH,
  RECEIPT_NUMBER,
  REQUEST_ACCESS_TOKEN,
  RETAIL_AUTH,
  RIGHT_TO_LEFT_LOCALES,
  SET_TITLE,
  SNOW_CREATE_INCIDENT_URL,
  TOKEN_V1,
  TOKEN_V2,
  TRANSLATIONS,
  TRUE_APP,
  WAIT_SECONDS_BEFORE_FAIL,
  WEBSITE_URL_JORDAN,
  WEBSITE_URL_NIKE,
  WORKSTATION_TYPE_CODES,
  WORLD_OF_FLIGHT
};
